/* recovered from production bundle — lib/constants */
// @ts-nocheck

export const THEME_KEY = 'dbtoolbox_theme';
export const LEGACY_THEME_KEY = 'navicat_theme';
export const TOKEN_KEY = 'dbtoolbox_token';
export const LEGACY_TOKEN_KEY = 'navicat_token';
